<template>
  <div class="instock-dialog-bd">
    <custom-dialog :title="$t('dms_bootCard_add_dialog.xin_zeng_kai_ji_ka')" :visible="visible" v-on="$listeners" width="1100px">
      <div class="dialog-body">
        <!-- 设备信息 -->
        <div class="handle-role">
          <div class="role-list">
            <ul>
              <li>
                <div class="item-head ub">
                  <el-row :gutter="10" class="ub-f1">
                    <el-col :span="4">
                      <h1>{{ 'RFID' }}</h1>
                    </el-col>
                    <el-col :span="5">
                      <h1>
                        {{ $t('dms_bootCard_add_dialog.ka_mian_bian_hao') }}
                      </h1>
                    </el-col>
                    <el-col :span="5">
                      <h1>{{ $t('dms_bootCard_add_dialog.yan_se') }}</h1>
                    </el-col>
                    <el-col :span="5">
                      <h1>{{ $t('Common.com_status') }}</h1>
                    </el-col>
                    <el-col :span="5">
                      <h1>
                        {{ $t('Common.com_remark') }}
                      </h1>
                    </el-col>
                  </el-row>
                  <div class="icon-box"></div>
                </div>
                <div class="children">
                  <div class="item ub" v-for="(item, index) in cardList" :key="index">
                    <el-row :gutter="10" class="ub-f1">
                      <!-- rfid -->
                      <el-col :span="4">
                        <el-input v-model="item.rfid" :placeholder="$t('Common.com_please_input')" style="width: 100%"></el-input>
                      </el-col>
                      <!-- cardNum 卡面编号-->
                      <el-col :span="5">
                        <el-input v-model="item.cardNum" :placeholder="$t('Common.com_please_input')" style="width: 100%"></el-input>
                      </el-col>
                      <!-- cardColor开机卡颜色 -->
                      <el-col :span="5">
                        <custom-select v-model="item.cardColor" code="dms_boot_card_color" :placeholder="index === 0 ? $t('Common.com_please_select') : $t('dms_bootCard_add_dialog.mo_ren_tong_shang')" width="100%"></custom-select>
                      </el-col>
                      <!-- state 状态 -->
                      <el-col :span="5">
                        <custom-select v-model="item.state" code="dms_boot_card_state" :placeholder="index === 0 ? $t('Common.com_please_select') : $t('dms_bootCard_add_dialog.mo_ren_tong_shang')" width="100%"></custom-select>
                      </el-col>
                      <!-- cardDesc 备注-->
                      <el-col :span="5">
                        <el-input v-model="item.cardDesc" :placeholder="index === 0 ? '' : $t('dms_bootCard_add_dialog.mo_ren_tong_shang')" style="width: 100%"></el-input>
                      </el-col>
                    </el-row>
                    <div class="icon-box" @click="deleteModel(index)">
                      <i v-if="index !== 0" class="icon icon-shanchu"></i>
                    </div>
                  </div>
                  <div class="add-child-btn" @click="addModel">
                    <div style="display: inline-block">
                      <i class="icon icon-add"></i>
                      <span>{{ $t('Common.com_added') }}</span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveConfirm">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      // visible: false,

      radio: false,
      formItem: {
        cardColor: '', // 开机卡颜色，字典分组代码：dms_boot_card_color
        cardDesc: '', // 卡号描述
        // cardId: '', // 开机卡Id， 编辑时必填
        cardNum: '', // 开机卡序号
        rfid: '', // RFID
        state: '', // 状态，字典分组代码：dms_boot_card_state
      },
      form: {
        // orgId: '',
        // orgName: '',
        shipmentNum: '',
      },
      cardList: [],
    };
  },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.init();
  },
  methods: {
    // 初始化
    init: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.form = JSON.parse(this.resetForm);
      const models = [];
      models.push(JSON.parse(JSON.stringify(this.formItem)));
      models.push(JSON.parse(JSON.stringify(this.formItem)));
      models.push(JSON.parse(JSON.stringify(this.formItem)));
      models.push(JSON.parse(JSON.stringify(this.formItem)));
      models.push(JSON.parse(JSON.stringify(this.formItem)));
      this.cardList = models;
      this.cardList[0].state = 1;
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },

    // 新增设备
    addModel: function () {
      this.cardList.push(JSON.parse(JSON.stringify(this.formItem)));
    },
    // 删除设备
    deleteModel: function (index) {
      this.cardList.splice(index, 1);
    },
    // 保存入库设备
    saveConfirm: function () {
      // 过滤全空的列
      const arr = this.cardList.filter(t => t.cardNum !== '' || t.rfid !== '' || t.cardColor !== '' || t.state !== '');
      if (arr.length === 0) {
        this.$message.error(this.$t('dms_bootCard_add_dialog.qtxkjk'));
        return;
      }
      const reqData = this.$formatCopyUp(arr, ['cardColor', 'state', 'cardDesc']);
      const hasEmpty = reqData.find(t => t.cardNum === '' || t.rfid === '' || t.cardColor === '' || t.state === '');
      if (hasEmpty) {
        this.$message.error(this.$t('dms_bootCard_add_dialog.qjsjtxwz'));
        return;
      }

      this.saveAddCrad(reqData);
    },
    // 保存新增推送规则
    saveAddCrad: function (reqData) {
      this.$postJSON(apis.bootCardAdd, reqData, true).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('success');
        this.closeDialog();
      });
    },
  },
};
</script>

<style lang="scss">
.instock-dialog-bd {
  .title {
    font-size: 16px;
    line-height: 24px;
    position: relative;
    padding-left: 12px;
    margin-bottom: 20px;
    color: #262626;
  }
  .title .bar {
    left: 0;
    width: 4px;
    height: 15px;
    background-color: #00afff;
  }
  .role-list {
    ul li {
      margin-top: 10px;
      border: 1px solid rgba(228, 228, 228, 1);
      &:first-child {
        margin-top: 0;
      }
    }
    .item-head {
      background: rgba(245, 245, 245, 1);
      border-bottom: 1px solid rgba(228, 228, 228, 1);
      padding: 0 10px;
      h1 {
        line-height: 40px;
        font-size: 12px;
        color: #262626;
        font-weight: bold;
        text-indent: 6px;
      }
      .icon-box {
        width: 30px;
        margin-left: 10px;
      }
    }
    .children {
      padding: 15px 0;
      .item {
        padding: 5px 10px 0;
        &:first-child {
          padding-top: 0;
        }
        .icon-box {
          line-height: 30px;
          width: 30px;
          margin-left: 10px;
          text-align: center;
          .icon {
            color: #00afff;
            font-size: 14px;
            cursor: pointer;
          }
        }
      }
      .el-input-group__append {
        border-radius: 0;
        .copy-up {
          padding: 0 8px;
          .el-radio__label {
            padding-left: 5px;
          }
        }
      }
    }
  }
  .other-role {
    margin-top: 30px;
  }

  .add-child-btn {
    background: rgba(245, 245, 245, 1);
    border: 1px dashed rgba(228, 228, 228, 1);
    line-height: 30px;
    text-align: center;
    color: #333333;
    font-size: 12px;
    margin: 14px 10px 0;
    cursor: pointer;
    .icon {
      color: #00afff;
      font-size: 10px;
      margin-right: 8px;
      float: left;
    }
  }
}
</style>
